import { Box } from "@chakra-ui/react";
import { colors } from "@/theme/colors";

// Pill-style on/off switch used by the feature-access screens.
export const FeatureToggle = ({ on, onChange, disabled, testId }) => (
  <Box
    as="button"
    type="button"
    onClick={disabled ? undefined : onChange}
    data-testid={testId}
    aria-checked={on}
    role="switch"
    w="42px"
    h="24px"
    flexShrink={0}
    borderRadius="full"
    bg={on ? colors.teal : colors.border}
    opacity={disabled ? 0.45 : 1}
    cursor={disabled ? "not-allowed" : "pointer"}
    position="relative"
    transition="background-color 0.15s ease"
  >
    <Box
      position="absolute"
      top="3px"
      left={on ? "21px" : "3px"}
      w="18px"
      h="18px"
      borderRadius="full"
      bg="white"
      boxShadow="0 1px 3px rgba(0,0,0,0.25)"
      transition="left 0.15s ease"
    />
  </Box>
);
